import { Position } from 'shared/context/types';

export const sortByComponentVar = (a: Position, b: Position): number => {
  if (a.componentVaR < b.componentVaR) return 1;
  if (a.componentVaR > b.componentVaR) return -1;

  if (a.name > b.name) return 1;
  if (a.name < b.name) return -1;

  return 0;
};
